/**
 * AnmcoExcellence CNC Multimedia -  Backend API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Tipi di grant per le richieste di auth
 */
export const GrantType = {
    Password: 'PASSWORD',
    RefreshToken: 'REFRESH_TOKEN'
} as const;
export type GrantType = typeof GrantType[keyof typeof GrantType];

